<template>
  <div class="app-notification">
    <div class="app-notification__content">
      <div class="d-flex align-center mb-2">
        <v-btn
          icon
          small
          class="mr-2"
          @click="changeSingleNotificationStatus(notification)"
        >
          <v-img
            v-if="notification.seen"
            max-width="24"
            src="/icons/icon_powiadomienie_przeczytane.svg"
          />
          <v-img
            v-else
            max-width="24"
            src="/icons/icon_powiadomienie_nieprzeczytane.svg"
          />
        </v-btn>

        <div>
          <h4 class="text-subtitle-2">
            {{ notification.title }}
          </h4>
          <div class="text-10">
            {{ notification.createdAt | dateWithTime }}
          </div>
        </div>
      </div>

      <div
        :class="{ 'light-grey--text': notification.seen }"
        v-html="notification.text"
      />
    </div>
    <v-btn
      depressed
      color="secondary"
      @click="navigateToResource(notification)"
    >
      Przejdź
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions('notifications', ['changeSingleNotificationStatus']),

    navigateToResource(notification) {
      let name;

      switch (notification.resourceType) {
        case 'Project':
          name = 'project-single';
          break;
        case 'VisualNumberRequest':
          name = 'kiw-single';
          break;
        case 'CommercialPrint':
          name = 'commercial-print-single';
          break;
        case 'DkoCooperationRequest':
          name = 'dko-cooperation-single';
          break;
        default:
          name = 'project-single';
      }

      this.changeSingleNotificationStatus({ ...notification, seen: false });
      this.$router.push({ name, params: { id: notification.resourceId } });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-notification {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1.5px solid #848a8925;
  &:last-child {
    border-bottom: none;
  }
  &__content {
    max-width: 560px;
    margin-right: 64px;
  }
}
</style>
